// Mock data for wedding website

export const couplePhotos = [
  "https://customer-assets.emergentagent.com/job_union-avril/artifacts/wvdlvwfi_HQFG1743.JPG",
  "https://customer-assets.emergentagent.com/job_union-avril/artifacts/gewo9d8y_IMG_0498.JPG",
  "https://customer-assets.emergentagent.com/job_union-avril/artifacts/8lffkdhz_IMG_0515.JPG",
  "https://customer-assets.emergentagent.com/job_union-avril/artifacts/kn14czc3_WhatsApp%20Image%202026-02-10%20at%2012.41.04.jpeg",
  "https://customer-assets.emergentagent.com/job_union-avril/artifacts/holy0i7c_WhatsApp%20Image%202026-03-02%20at%2015.21.41.jpeg",
  "https://customer-assets.emergentagent.com/job_union-avril/artifacts/742wsmsp_3.jpeg",
  "https://customer-assets.emergentagent.com/job_union-avril/artifacts/81spxrub_4.jpeg"
];

export const heroPhoto = "https://customer-assets.emergentagent.com/job_union-avril/artifacts/spp4v3s1_HATEM-50.jpg";

export const weddingDetails = {
  bride: "Nourhene",
  groom: "Hatem",
  date: "2027-05-01",
  dateDisplay: "1er Mai 2027",
  venue: "Domaine Tarenti",
  location: "Mornag, Tunisie",
  fullAddress: "1135 Chebbeda BP75, Mornag, Tunisie",
  coordinates: { lat: 36.6799, lng: 10.2311 } // Mornag approximate coordinates
};

export const welcomeMessage = {
  title: "Un mot pour vous",
  message: "Chers amis, chère famille,\n\nC'est avec une immense joie et beaucoup d'émotion que nous vous invitons à partager avec nous le plus beau jour de notre vie.\n\nVotre présence à nos côtés pour célébrer notre union est le plus précieux des cadeaux. Ensemble, nous créerons des souvenirs inoubliables qui resteront gravés dans nos cœurs pour toujours.\n\nMerci d'être là."
};

export const ourStory = {
  timeline: [],
  mainStory: "Notre histoire a commencé… et elle continue de naître à chaque sourire, à chaque instant passé ensemble 💫\n\nUne rencontre qui a changé nos vies vers le meilleur."
};

export const program = [
  {
    time: "16h00",
    title: "Accueil des invités",
    description: "Station soft au Domaine Tarenti",
    icon: "users"
  },
  {
    time: "17h00",
    title: "Cérémonie",
    description: "Signature du contrat de mariage",
    icon: "heart"
  },
  {
    time: "18h00",
    title: "Réception & Restauration",
    description: "Stands gourmands, buffet raffiné et espaces jeux",
    icon: "utensils"
  },
  {
    time: "20h00",
    title: "Soirée dansante",
    description: "Animation musicale en live",
    icon: "music"
  },
  {
    time: "00h00",
    title: "Feu de camp & Marshmallow",
    description: "Moment convivial autour du feu",
    icon: "flame"
  },
  {
    time: "01h00",
    title: "Départ",
    description: "Fin de soirée",
    icon: "moon"
  }
];

export const venueDescription = "Oasis improbable aux portes de Tunis, le Domaine Tarenti offre un cadre enchanteur pour célébrer notre union. Entre oliviers centenaires et architecture élégante, ce lieu unique allie charme authentique et raffinement moderne.";

// Mock RSVP submissions (will be replaced with backend)
export let mockRSVPs = [];

export const submitRSVP = (rsvpData) => {
  const newRSVP = {
    id: Date.now(),
    ...rsvpData,
    submittedAt: new Date().toISOString()
  };
  mockRSVPs.push(newRSVP);
  return Promise.resolve(newRSVP);
};

// Liste des invités (à personnaliser avec vos vrais invités)
export const guestsList = [
  "Sélectionnez votre nom",
  "Ahmed Ben Ali",
  "Fatma Trabelsi",
  "Mohamed Gharbi",
  "Leila Hamdi",
  "Karim Mansour",
  "Salma Ayari",
  "Youssef Jebali",
  "Amira Toumi",
  "Mehdi Bouzid",
  "Sonia Nasri",
  "Famille Ben Salah",
  "Famille Kadri",
  "Famille Dridi",
  "Autre (préciser dans le message)"
];

export const coupleMessage = {
  title: "Un mot pour vous",
  message: "Chers amis, chère famille,\n\nC'est avec une immense joie que nous vous invitons à célébrer avec nous le plus beau jour de notre vie. Votre présence à nos côtés rendra ce moment encore plus précieux et inoubliable.\n\nMerci d'être là pour partager notre bonheur.\n\nAvec tout notre amour,\nHatem & Nourhene"
};
